export enum SubscriptionStatus {
    Active = 0,
    ExpiringSoon = 1,
    Expired = 2,
    Locked = 3
}
